export default __webpack_public_path__ + "img/94240029ed5e01f3b430d184481a61e8.svg";